// extracted by mini-css-extract-plugin
export default {"field":"FormToggle_field__TQuKm","labelWrapper":"FormToggle_labelWrapper__lvQC-","label":"FormToggle_label__LhtOx","formError":"FormToggle_formError__jcmkW"};